import script from "./Surcharge.vue?vue&type=script&setup=true&lang=js"
export * from "./Surcharge.vue?vue&type=script&setup=true&lang=js"

import "./Surcharge.vue?vue&type=style&index=0&id=7ab45bcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ab45bcc"]])

export default __exports__